// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"deposit-contribution_saveTag__aDvd2","text":"deposit-contribution_text__3OoPv"};